import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { i18n } from '@zet/localization'

import { enrollToTraining } from '../functions/enrollToTraining'

export function useEnrollToTraining(_onSuccess?: () => void) {
  const queryClient = useQueryClient()
  const toast = useToast()
  return useMutation(enrollToTraining, {
    onSuccess(response) {
      queryClient.invalidateQueries({ queryKey: ['home-widgets'] })
      queryClient.invalidateQueries({ queryKey: ['useUpcomingTrainings'] })
      queryClient.invalidateQueries({ queryKey: ['useFirstTraining'] })
      queryClient.invalidateQueries({ queryKey: ['userTraining'] })
      queryClient.invalidateQueries({ queryKey: ['brandsTraining'] })
      toast?.show({
        intent: 'success',
        heading: i18n.t('toastMessages.success'),
        description: i18n.t('toastMessages.enrolledSuccessfully'),
        hideAfter: 3000,
      })
      _onSuccess?.()
    },
    onError(error) {
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description: i18n.t('toastMessages.trainingFailed'),
        hideAfter: 3000,
      })
    },
  })
}
